import {Component, Inject, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {DeviceDetectorService} from "../../../core/services/device-detector.service";

@Component({
  selector: 'app-modal-confirmacao',
  templateUrl: './modal-confirmacao.component.html',
  styleUrls: ['./modal-confirmacao.component.scss']
})
export class ModalConfirmacaoComponent {
  tituloConfirmarAcao;
  descricaoConfirmarAcao;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public dataBottom: any,
    @Optional() public dialogRef: MatDialogRef<ModalConfirmacaoComponent>,
    @Optional() private bottomSheetRef: MatBottomSheetRef<ModalConfirmacaoComponent>,
    protected deviceDetectorService: DeviceDetectorService,
  ) {
    console.log(this.data);
    if(this.data) {
      this.tituloConfirmarAcao = this.data.tituloConfirmarAcao ?? '-';
      this.descricaoConfirmarAcao = this.data.descricaoConfirmarAcao ?? '-';
    } else {
      this.tituloConfirmarAcao = this.dataBottom.tituloConfirmarAcao ?? '-';
      this.descricaoConfirmarAcao = this.dataBottom.descricaoConfirmarAcao ?? '-';
    }
  }

  fechar(): void {
    if (!this.deviceDetectorService.isMobile()) {
      this.dialogRef.close(false);
    } else {
      this.bottomSheetRef.dismiss(false);
    }
  }

  enviar(): void {
    if (!this.deviceDetectorService.isMobile()) {
      this.dialogRef.close(true);
    } else {
      this.bottomSheetRef.dismiss(true);
    }
  }
}
